// extracted by css-extract-rspack-plugin
export default {"dragHandleContainer":"vhAEF","dragHandle":"qIeul"};